<template>
    <div>
        <ProjectServicesTop />
        <div class="titleStyle">
            <div class="titleFont">供应链服务</div>
            <div class="conentFont">
                <div class="divide"></div>
                <span class="enFont">Supply chain services</span>
                <div class="divide"></div>
            </div>
        </div>
        <div class="describeFont">
            {{ dataList.description }}
        </div>
        <div class="BusinessLogisticsServiceList">
            <div
                class="listItem"
                v-for="(item, idx) in dataList.cmsArticleList"
                :key="idx"
                :style="{
                    backgroundImage: 'url(' + item.image + ')',
                }"
            >
                {{ item.title }}
            </div>
            <div class="omit">⋅⋅⋅</div>
        </div>
    </div>
</template>
<script>
import ProjectServicesTop from "@/components/ProjectServicesTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "BusinessLogisticsService",
    components: {
        ProjectServicesTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryServiceList",
            dataList: {},
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 50,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    that.dataList = res.result.records[0];
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.bgSet {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.describeFont {
    .typeArea();
    padding: 0 50px;
    font-size: 18px;
    letter-spacing: 1.1px;
    line-height: 1.6em;
    color: #333333;
    margin-bottom: 100px;
}
.BusinessLogisticsServiceList {
    .typeArea();
    display: flex;
    margin-bottom: 70px;
    .listItem {
        .bgSet();
        width: 470px;
        height: 400px;
        font-family: "优设标题黑";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .omit {
        width: 160px;
        height: 400px;
        background-color: #0052d9;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 64px;
        letter-spacing: 2px;
    }
}
</style>
